export function getUploadDestinationPath(fileUploadState) {
    return fileUploadState.parent
        ? fileUploadState.parent.webDavUrl.replace(fileUploadState.parent['@sharePoint.listUrl'], '')
        : undefined;
}
//# sourceMappingURL=getUploadDestinationPath.js.map